import { createSelector } from "reselect"
import { get, chain, map, some, size, update, isArray } from "lodash"
import moment from "moment"
import { getSelectedMetric } from "./metrics"
import { getItems } from "./items"

const EMPTY_OBJECT = {}
const getData0 = state => get(state, "global.data.compareCompositionPositionSet0.data.model.simulation.composition")
const getData1 = state => get(state, "global.data.compareCompositionPositionSet1.data.model.simulation.composition")
const getData2 = state => get(state, "global.data.compareCompositionPositionSet2.data.model.simulation.composition")
const getData3 = state => get(state, "global.data.compareCompositionPositionSet3.data.model.simulation.composition")
const getData4 = state => get(state, "global.data.compareCompositionPositionSet4.data.model.simulation.composition")
const getPositionSets = (state, props) => get(props, "positionSets")

export const getMissingReferenceEquity = state => get(state, "modules.compareComposition.missingReferenceEquity", [])

function getDataMap({ chartValue: selector }, data) {
  if (!data) {
    return null
  }

  return chain(data)
    .keyBy("date")
    .mapValues(selector)
    .value()
}

const getDataMap1 = createSelector([getSelectedMetric, getData1], getDataMap)
const getDataMap2 = createSelector([getSelectedMetric, getData2], getDataMap)
const getDataMap3 = createSelector([getSelectedMetric, getData3], getDataMap)
const getDataMap4 = createSelector([getSelectedMetric, getData4], getDataMap)

function getDataMapValue(dataMap, date, defaultToZero, metricId, errors, n) {
  if (dataMap) {
    const value = get(dataMap, date, 0)
    if (!value && defaultToZero[n] && metricId === "equity") {
      update(errors, n, arr => isArray(arr) ? [...arr, date] : [date])
      return 0
    }

    return value
  }

  return undefined
}

const getDataAndErrors = createSelector(
  [getSelectedMetric, getData0, getDataMap1, getDataMap2, getDataMap3, getDataMap4],
  (metricData, data, dataMap1, dataMap2, dataMap3, dataMap4) => {
    // We don't want all nulls equity to default to zero and be shown in the graph
    const defaultToZero = [
      some(data, elem => !!elem.referenceEquity),
      ...map([dataMap1, dataMap2, dataMap3, dataMap4], elem => some(elem, data => !!data)),
    ]

    const errors = EMPTY_OBJECT

    const resultData = map(data, (item) => {
      let currentValue = metricData.chartValue(item)
      if (metricData.id === "equity" && !currentValue && defaultToZero[0]) {
        currentValue = 0
        update(errors, 0, arr => isArray(arr) ? [...arr, item.date] : [item.date])
      }

      return {
        date: moment(item.date),
        0: currentValue,
        1: getDataMapValue(dataMap1, item.date, defaultToZero, metricData.id, errors, 1),
        2: getDataMapValue(dataMap2, item.date, defaultToZero, metricData.id, errors, 2),
        3: getDataMapValue(dataMap3, item.date, defaultToZero, metricData.id, errors, 3),
        4: getDataMapValue(dataMap4, item.date, defaultToZero, metricData.id, errors, 4),
      }
    })

    return { data: resultData, errors }
  },
)

export const getData = createSelector(
  [getDataAndErrors],
  ({ data }) => data)

export const getMissingEquityItemsDates = createSelector(
  [getDataAndErrors, getData, getItems, getPositionSets],
  ({ errors }, data, items, positionSets) => {
    if (!data || size(data) === 0) {
      return null
    }

    return map(errors, (elem, i) => {
      return {
        label: get(items, `${i}.label`, ""),
        id: get(positionSets, `${i}.id`),
        type: get(positionSets, `${i}.type`),
        dates: elem,
      }
    })
  },
)
